import React from 'react';
import { Form, InputNumber, Tooltip, Button, Popconfirm, message, Select, DatePicker, Input } from 'antd';
import ModalDom from '../../../../../components/Modal';
import { post, config, postFrom } from '../../../../../axios';
import DetailTitle from '../../../../../components/DetailTitle';
import { CustomRow, CustomCol } from '../../../../../components/Custom';
import { moneyAddComma, handleDeepCopy } from '../../../../../utils';
import moment from 'moment';

const Option = Select.Option;

class Page extends React.Component {
    constructor() {
        super();
        this.initState = { //初始化的单条数据
            loading: false,
            data: {},
            receivablesType: [], //收款类别
            billData: [], //账单
        };
        this.state = {
            ...handleDeepCopy(this.initState),
        };
    }

    handleCancel = () => { //关闭页面
        this.setState({ ...handleDeepCopy(this.initState) }, () => {
            this.props.handleCancel();
        });
    }

    handleMinus = (index) => {
        let { billData } = this.state;
        billData.splice(index, 1);
        this.setState({ billData });
    }

    handlePlus = () => {
        let { receivablesType, billData } = this.state;
        let receivablesItem = receivablesType[billData.length];
        let billItem = billData[billData.length - 1];
        billData.push({
            key: billItem ? billItem.key + 1 : 0,
            mustPayDate: undefined,
            feeName: receivablesItem ? receivablesItem.dicValue : '',
            beginDate: undefined,
            endDate: moment(),
            amount: 0,
            feeRemark: ''
        });
        this.setState({ billData });
    }

    loadPack = ({ id }) => {
        this.setState({ loading: true });
        postFrom({ url: config.API_rentcontract_getRentContractById, data: { rentContractId: id } }).then(res => {
            this.setState({ loading: false, data: res });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });

        postFrom({ url: config.API_dictionary_findList, data: { groupName: '收款类别' } }).then(res => {
            this.setState({ receivablesType: res });
        }).catch(err => {
            message.error(err.message || '获取收款类别失败');
        });
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            let { billData, data: contractData } = this.state;

            if (error) {
                message.error('请填写所有必填项！');
            } else {
                if (billData.length === 0) {
                    this.handleCancel();
                } else if (contractData.id) {
                    this.setState({ loading: true });
                    let valueKeys = Object.keys(values);
                    valueKeys = valueKeys.filter((item, index) => {
                        if (/^mustPayDate-[\d]+$/.test(item)) return item;
                    });
                    let billAddParamList = valueKeys.map((item, index) => {
                        let num = item.split('-')[1];
                        item = {
                            amount: +values[`amount-${num}`],
                            beginDate: values[`beginDate-${num}`] ? values[`beginDate-${num}`].format('YYYY-MM-DD') : '',
                            endDate: values[`endDate-${num}`] ? values[`endDate-${num}`].format('YYYY-MM-DD') : '',
                            feeName: values[`feeName-${num}`],
                            feeRemark: values[`feeRemark-${num}`],
                            mustPayDate: values[`mustPayDate-${num}`] ? values[`mustPayDate-${num}`].format('YYYY-MM-DD') : ''
                        };
                        return item
                    });
                    let data = {
                        billAddParamList,
                        contractId: contractData.id
                    }
                    post({ url: config.API_bill_addManual, data }).then(res => {
                        message.success('添加账单成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '添加账单失败');
                        this.setState({ loading: false });
                    });
                } else {
                    message.error('未查询到合同id');
                }
            }
        })
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    render() {
        let { visible, form: { getFieldDecorator } } = this.props;
        let {
            loading,
            data,
            receivablesType,
            billData,
        } = this.state;

        return <ModalDom
            title="添加账单"
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form>
                    <CustomRow title="房源">
                        <CustomCol label="小区/楼栋" required={false}>
                            <span className="not-edit">{data.buildingName}</span>
                        </CustomCol>
                        <CustomCol label="房号" required={false}>
                            <span className="not-edit">{data.roomNo}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow title="租客" divider>
                        <CustomCol label="姓名" required={false}>
                            <span className="not-edit">{data.customerName}</span>
                        </CustomCol>
                        <CustomCol label="证件号码" required={false}>
                            <span className="not-edit">{data.customerIdNumber}</span>
                        </CustomCol>
                        <CustomCol label="手机号码" required={false}>
                            <span className="not-edit">{data.customerPhone}</span>
                        </CustomCol>
                    </CustomRow>
                    <DetailTitle title="账单" />
                    <div className="tableBox">
                        <div className="tableTitle">
                            <div style={{ flex: 1 }} className="xinxin xinxinColor">应收日期</div>
                            <div style={{ flex: 1 }} className="xinxin xinxinColor">收款类别</div>
                            <div style={{ flex: 2 }} className="xinxin xinxinColor">周期</div>
                            <div style={{ flex: 1 }} className="xinxin xinxinColor">金额（元）</div>
                            <div style={{ flex: 2 }}>说明</div>
                            <div style={{ flex: '0 0 100px' }}>操作</div>
                        </div>
                        <div className="tableBody">
                            {
                                billData.length
                                    ? billData.map((item, index) => {
                                        return <div className="tableBodyRow" key={index}>
                                            <div style={{ flex: 1, alignItems: 'center' }}>
                                                {getFieldDecorator(`mustPayDate-${item.key}`, {
                                                    rules: [{
                                                        required: true, message: '请输入',
                                                    }],
                                                    initialValue: item.mustPayDate
                                                })(
                                                    <DatePicker
                                                        allowClear={false}
                                                    />
                                                )}
                                            </div>
                                            <div style={{ flex: 1, alignItems: 'center' }}>
                                                {getFieldDecorator(`feeName-${item.key}`, {
                                                    rules: [{
                                                        required: true, message: '请输入',
                                                    }],
                                                    initialValue: item.feeName
                                                })(
                                                    <Select
                                                        placeholder="请选择"
                                                    >
                                                        {receivablesType.map((item, index) => <Option value={item.dicValue} key={index}>{item.dicValue}</Option>)}
                                                    </Select>
                                                )}
                                            </div>
                                            <div style={{ flex: 2 }}>
                                                {getFieldDecorator(`beginDate-${item.key}`, {
                                                    rules: [{
                                                        required: true, message: '请输入',
                                                    }],
                                                    initialValue: item.beginDate
                                                })(
                                                    <DatePicker
                                                        allowClear={false}
                                                    />
                                                )}
                                                {getFieldDecorator(`endDate-${item.key}`, {
                                                    rules: [{
                                                        required: true, message: '请输入',
                                                    }],
                                                    initialValue: item.endDate
                                                })(
                                                    <DatePicker
                                                        allowClear={false}
                                                    />
                                                )}
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                {getFieldDecorator(`amount-${item.key}`, {
                                                    initialValue: item.amount
                                                })(
                                                    <InputNumber
                                                        className="money-right"
                                                        style={{ paddingRight: '25px' }}
                                                        min={0}
                                                        formatter={value => value !== '' ? value : 0}
                                                        onChange={(value) => {
                                                            billData[index].amount = value;
                                                            this.setState({ billData });
                                                        }}
                                                    />
                                                )}
                                            </div>
                                            <div style={{ flex: 2 }}>
                                                {getFieldDecorator(`feeRemark-${item.key}`, {
                                                    initialValue: item.feeRemark
                                                })(
                                                    <Input
                                                        autoComplete="off"
                                                    />
                                                )}
                                            </div>
                                            <div style={{ flex: '0 0 100px' }}>
                                                <Popconfirm
                                                    placement="topRight"
                                                    title={'此删除操作不可恢复，确定删除吗？'}
                                                    onConfirm={() => {
                                                        this.handleMinus(index)
                                                    }}
                                                    okText="删除"
                                                    cancelText="取消"
                                                >
                                                    <span className="showClickDetail">删除</span>
                                                </Popconfirm>
                                            </div>
                                        </div>
                                    })
                                    : <div className="tableBodyRow" style={{ height: '34px', lineHeight: '34px', justifyContent: 'center', color: '#888' }}>暂无数据！</div>
                            }
                            <div className="tableBodyRow" style={{ justifyContent: 'space-between', alignItems: 'center', height: '34px', padding: '0 35px 0 20px' }}>
                                <span>应收合计：<span style={{ color: 'red' }}>{moneyAddComma(billData.length ? billData.reduce((total, item) => total + item.amount, 0) : 0)}</span>元</span>
                                <Tooltip placement="bottomLeft" title={"添加一行账单输入框"}>
                                    <Button onClick={this.handlePlus} style={{ width: '24px', height: '24px', lineHeight: '16px', fontSize: '14px' }} shape="circle" icon="plus" />
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </ModalDom>
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/RentContract/components/List/AddBill/index.js